import styled from "styled-components"

export const ContainerAtencionSinTurno = styled.div`
    width: 100vw;
    height: calc(100vh - 30vh);
    height: calc(100dvh - 30dvh);
    display: flex;
    align-items: center;
    gap: 30px;
    flex-direction: column; 
    overflow: scroll;
    position: absolute;
    bottom: 1vh;
`;